<template>
	<div id="contact" style="overflow:hidden">
		<PagesHeading />
		<div class="row m-0">
			<div class="col-sm-8 col-12 message-form">
				<h5 class="contact-title mb-4 mt-5 mt-sm-0">
					{{ $t('contact-us.send-your-message') }}
					<i class="far fa-envelope"></i>
				</h5>
				<div v-if="success" class="alert alert-success">
					<span>{{$t('contact-us.success')}}</span>
					<i class="fas fa-check text-success mx-1"></i>
				</div>
				<div v-if="error" class="alert alert-danger">
					<ul class="mb-0 pl-0 list-unstyled">
						<li>➜ {{ error }}</li>
					</ul>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label class="label">{{ $t('contact-us.email') }}</label>
						<input :disabled="success" :class="{ 'is-invalid': !emailValid }" v-model="email" type="email" class="form-control text-start"
							name="email" :placeholder="$t('contact-us.enter-email-address')" required>
					</div>
					<div class="form-group col-md-6">
						<label class="label">{{ $t('contact-us.name') }}</label>
						<input :disabled="success" :class="{ 'is-invalid': !nameValid }" v-model="name" type="text" class="form-control text-start"
							name="name" :placeholder="$t('contact-us.enter-full-name')" required>
					</div>
				</div>
				<div class="form-group py-2">
					<label class="my-1 mr-2 label">{{ $t('contact-us.type') }}</label>
					<select :disabled="success" :class="{ 'is-invalid': !typeValid }" v-model="type" class="custom-select text-start my-1 mr-sm-2" name="type"
						required>
						<option value="general">
							{{ $t('contact-us.feedback-types.general') }}
						</option>
						<option value="enquiry">
							{{ $t('contact-us.feedback-types.enquiry') }}
						</option>
						<option value="complaint">
							{{ $t('contact-us.feedback-types.complaint') }}
						</option>
					</select>
				</div>
				<div class="form-group">
					<label class="label">{{ $t('contact-us.body') }}</label>
					<textarea :disabled="success" :class="{ 'is-invalid': !messageValid }" v-model="body" class="form-control text-start" name="body" rows="3"
						required></textarea>
				</div>
				<button :disabled="success||loading" @click="sendFeedback()" class="btn btn-warning mt-3">
					<div v-if="loading" class="load-9 px-4">
						<div class="spinner">
							<div class="bubble-1"></div>
							<div class="bubble-2"></div>
						</div>
					</div>
					<div v-else>
						{{ $t('contact-us.send') }}
						<i :class="`fas fa-arrow-${dir} mx-2`"></i>
					</div>
				</button>
			</div>

			<div class="col-sm-4 col-12 contact-info px-3">
				<h5 class="contact-title mb-4">
					{{ $t('contact-us.contact-info') }}
				</h5>
				<div v-if="getContacts.phone" class="row no-gutters mt-4 ltr text-left">
					<div class="col-auto">
						<span class="fas fa-fw fa-mobile-alt mx-2"></span>
					</div>
					<div class="col rtl text-white">
						{{ $t('common.phone1') }}
						<a class="link-contact" :href="'tel:' + getContacts.phone" target="_blank" rel="noopener noreferrer">
							{{ getContacts.phone }}
						</a>
					</div>
				</div>
				<div v-if="getContacts.mobile" class="row no-gutters mt-4 ltr text-left">
					<div class="col-auto">
						<span class="fas fa-fw fa-mobile-alt mx-2"></span>
					</div>
					<div class="col rtl text-white">
						{{ $t('common.phone2') }}
						<a class="link-contact" :href="'tel:' + getContacts.mobile" target="_blank" rel="noopener noreferrer">
							{{ getContacts.mobile }}
						</a>
					</div>
				</div>
				<div v-if="getContacts.whatsapp" class="row no-gutters mt-4 ltr text-left">
					<div class="col-auto">
						<span class="fas fa-fw fa-mobile-alt mx-2"></span>
					</div>
					<div class="col rtl text-white">
						{{ $t('common.phone3') }}
						<a class="link-contact" :href="'tel:' + getContacts.whatsapp" target="_blank" rel="noopener noreferrer">
							{{ getContacts.whatsapp }}
						</a>
					</div>
				</div>
				<div class="row no-gutters mt-4 ltr text-left">
					<div class="col-auto">
						<span class="fas fa-fw fa-map-marker-alt mx-2"></span>
					</div>
					<div class="col rtl text-white">
						{{ $t('contact-us.address-head-office') }}
					</div>
				</div>
				<div class="row no-gutters mt-4 ltr text-left">
					<div class="col-auto">
						<span class="fas fa-fw fa-map-marker-alt mx-2"></span>
					</div>
					<div class="col rtl text-white">
						{{ $t('contact-us.address-factory') }}
					</div>
				</div>
				<div class="media mt-5">
					<a v-if="getContacts.facebook" :href="getContacts.facebook" target="_blank" rel="noopener noreferrer">
						<span><i class="fab fa-facebook-square fa-fw mr-3"></i></span>
					</a>
					<a v-if="getContacts.instagram" :href="getContacts.instagram" target="_blank" rel="noopener noreferrer">
						<span><i class="fab fa-instagram fa-fw mr-3"></i></span>
					</a>
					<a v-if="getContacts.telegram" :href="getContacts.telegram" target="_blank" rel="noopener noreferrer">
						<span><i class="fab fa-telegram fa-fw mr-3"></i></span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import PagesHeading from '@/components/PagesHeading.vue';
import { mapGetters } from 'vuex';
export default {
	components: {
		PagesHeading
	},
	computed: {
		...mapGetters({
			getContacts: 'branches/getContacts'
		})
	},
	data() {
		return {
			name: null,
			email: null,
			type: null,
			body: null,
			number: null,
			loading: false,
			nameValid: true,
			emailValid: true,
			typeValid: true,
			messageValid: true,
			success: false,
			error: false,
			dir: ''
		}
	},
	mounted() {
		this.dir = localStorage.getItem('lang') === 'en' ? 'right' : 'left'
	},
	methods: {
		async sendFeedback() {
			if (this.valid()) {
				this.loading = true;
				await this.$store.dispatch('contactUs/sendFeedback', {
					name: this.name,
					email: this.email,
					type: this.type,
					body: this.body,
					phone: '123456789'
				})
					.then(() => {
						this.name = null;
						this.email = null;
						this.body = null;
						this.type = null;
						this.success = true;
					})
					.catch((error) => {
						this.error = error;
					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		valid() {
			this.nameValid = Boolean(this.name);
			this.typeValid = Boolean(this.type);
			this.messageValid = Boolean(this.body);
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			this.emailValid = emailRegex.test(this.email);
			return this.nameValid && this.emailValid && this.typeValid && this.messageValid;
		}
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}

.contact-title {
	font-weight: 700;
	color: #FC9F2C;
}

.contact-title i {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	align-content: center;
	font-size: 30px;
	margin-top: -24px;
}

.contact-info {
	background-color: #FC9F2C;
	background-image: url('/public/images/message.png');
	background-position: bottom right;
	background-size: 66% auto;
	background-repeat: no-repeat no-repeat;
	padding: 4%;
}

.contact-info h5 {
	color: white;
}

.contact-info i {
	color: #f7f7f7;
}

.contact-info i:hover {
	color: #c3c3c3;
}

.contact-info span {
	color: white;
	font-size: 15px;
}

.message-form {
	padding: 4% 6%;
}

.label {
	color: #c3c3c3;
	font-weight: 600;
}

.btn-warning {
	color: #ffffff;
	background-color: #FC9F2C;
	border-color: #FC9F2C;
	border-radius: 5px;
}

.btn-warning:hover {
	color: white;
	background-color: #e08d00;
	border-color: #e08d00;
}

.btn-warning:focus {
	box-shadow: 0 0 0 0.2rem rgba(249, 166, 26, 0.46);
}

.btn-warning:not(:disabled):not(.disabled):active {
	color: #212529;
	background-color: #f9a61a;
	border-color: #f9a61a;
}

.media a {
	color: black;
}

.media a:hover {
	color: #f3efef;
}

.form-control:focus {
	color: #292728;
	background-color: #f3efef;
	border-color: #f9a61a57;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgba(249, 166, 26, 0.2);
}

.custom-select:focus {
	border-color: #f9a61a57;
	outline: 0;
	box-shadow: inset 0 1px 2px rgba(249, 166, 26, 0.52), 0 0 0 0.2rem rgba(249, 166, 26, 0.2);
}

.form-control,
.custom-select {
	color: #292728;
	background-color: #f7f7f7;
	border-color: #f3efef;
	border-radius: 5px;
}

.media .fas,
.media .fab,
.media .far,
.media .fa {
	font-size: 2rem;
}

.link-contact {
	color: #ffffff;
	text-decoration: none;
	display: inline-block;
}

.link-contact:hover {
	text-decoration: underline !important;
	cursor: pointer;
}

html[dir='rtl'] .form-group {
	text-align: right;
}

html[dir='rtl'] .contact-title {
	text-align: right;
}

html[dir='rtl'] .rtl {
	text-align: right;
}

html[dir='rtl'] .contact-info {
	background-color: #FC9F2C;
	background-image: url('/public/images/message-ar.png');
	background-position: bottom left;
	background-size: 66% auto;
	background-repeat: no-repeat no-repeat;
	padding: 4%;
}
.spinner{
	position:static;
	height: 20px;
	width:20px;
}
.bubble-1,.bubble-2{
	width: 12px;
	height: 12px;
}
</style>